/** Shown at checkout when pickup items are not yet at the selected store. */
export default function TransitCooldownBanner({ items }) {
    const itemsNeedingTransit = items.filter((i) => i.requiresTransit);
    if (!itemsNeedingTransit.length) return null;

    return (
        <div className="bg-blue-50/50 dark:bg-blue-950/20 border border-blue-100 dark:border-blue-900/50 rounded-xl p-4">
            <div className="flex items-start gap-3">
                <i className="ri-information-line text-blue-600 dark:text-blue-400 text-lg mt-0.5 flex-shrink-0" />
                <ul className="text-xs text-blue-800 dark:text-blue-400 space-y-1 list-disc list-inside">
                    <li>You will receive an email when stock arrives and your order is ready.</li>
                    <li>Track your order in the My Orders section.</li>
                </ul>
            </div>
        </div>
    );
}
